import propertyObjectClassMapping from 'constants/propertyObjectClassMapping';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getPropertyObjectTypes } from '../../services/API';

import { actionTypes, requestFailure, requestSuccess } from './actions';

export default function* propertyObjectTypesSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}

export function* getData(action) {
  const response = yield call(getPropertyObjectTypes, action.payload);
  yield response.isOk ? handleRequestSuccess(response.data) : put(requestFailure(response.error));
}

function* handleRequestSuccess(data) {
  data.forEach(function (type) {
    propertyObjectClassMapping[type.id].typeTitle = type.title;
  });
  yield put(requestSuccess(data));
}
